import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import moment from 'moment';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { AppHelper } from '../../helpers/AppHelper';
import { Controller } from '../../common/Controller';
import { settings, relativesettings, relativesettingsLess, relativeImageSliderSettings } from './SliderSettings';
import { SearchTextField } from './SearchTextField';
import { Helper } from '../../common/helpers/Helper';
import { AppConfig } from '../../AppConfig';
import Grid from '@material-ui/core/Grid';

export class EventDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      player: 'play_arrow',
      selectedImageIndex: 0,
      selectedRelatedEventIndex: 0,
    }
    this.pause = true;
    this.play = false;
    this.playerFnId = null;
    this.setImageContainerDimension()
  }

  setImageContainerDimension = () => {
    if (window.innerWidth > 768) {
      this.imgContainerWidth = window.innerWidth * .9 * .84 * .64 //TODO
    } else {
      this.imgContainerWidth = window.innerWidth //TODO
    }
    this.imgContainerHeight = this.imgContainerWidth * this.props.streamContentHeight / this.props.streamContentWidth
  }

  searchBox = () => {
    return (
      <SearchTextField
        searchHandler={this.props.searchHandler} />
    )
  }

  showRelatedImages = (index) => {
    this.setState({
      selectedImageIndex: index,
      relatedEvent: false
    })
    this.props.imageSliderHandler(true)
  }

  closeRelatedImages = () => {
    this.setState({ selectedImageIndex: 0 })
    this.props.imageSliderHandler(false)
  }

  showRelatedEvents = (index, item) => {
    this.setState({
      relatedEvent: true,
      selectedRelatedEventIndex: index,
    })
    this.props.imageSliderHandler(false)
    this.props.onRelatedEventTileClick(item)
  }

  closeRelatedEvent = () => {
    this.setState({ relatedEvent: false, selectedRelatedEventIndex: 0 })
  }

  renderEventHeader = (item) => {

    return (
      <div className={this.props.relativeImageSliderMode ? css(Styles.eventItemHeaderConatinerRelativeOpen) : css(Styles.eventItemHeaderConatinerRelativeClose)}>
        <div className={css(Styles.eventHeaderOuterContent)}>
          <div className={css(Styles.eventItemHeaderInnerContent)}>

            {this.props.searchHandler &&
              <div className={css(Styles.eventItemHeaderSearchInnerContent)}>
                {this.searchBox()}
              </div>
            }

            {item &&
              <p className={css(Styles.eventItemTime)}>{moment(item.event_time).format('MMM DD, YYYY, h:mm:ss A')}</p>
            }

            {item &&
              <p className={css(Styles.eventItemTitle)}>{item.name}</p>
            }

            {item &&
              <div className={css(Styles.eventItemInnerContent)}>
                <div className={css(Styles.eventItemOuterTagContent)}>

                  <div className={css(Styles.eventItemInnerTagContent)}>
                    {item.type &&
                      <div className={css(Styles.eventItemType)}>{item.type}</div>
                    }

                    <div className={css(Styles.eventItemType, Styles.eventItemTypePriority)}>
                      {AppHelper.getPriorityStr(item.priority)}
                    </div>

                  </div>
                </div>

                {item && item.tags &&
                  <div className={css(Styles.eventEditContainer, Styles.eventEditContainerStyle)}>
                    {Object.keys(item.tags).map(key => {
                      return (
                        <div className={css(Styles.tagContainer)}>
                          <p className={css(Styles.tagKey)}>{key}</p>
                          <p className={css(Styles.tagValue)}>{item.tags[key]}</p>
                        </div>
                      )
                    })}
                  </div>
                }

              </div>
            }
          </div>
        </div>
      </div>
    )
  }

  processImages = (item) => {
    let eventImages = [item.image]
    if (item.additionalImages && item.additionalImages.length > 0) {
      eventImages = eventImages.concat(item.additionalImages)
    }
    return eventImages
  }

  renderRelativeImageSlider = (item) => {
    if (!item) return

    const eventImages = this.processImages(item)
    if (this.props.relativeImageSliderMode) {
      return (
        <div className={css(Styles.imageSliderContainer)}>
          {this.props.relativeImageSliderMode &&
            <div className={css(Styles.eventLiveFeed)} onClick={() => this.closeRelatedImages()}>
              <img src={require('../../assets/images/close-img-white.svg')} className={css(CommonStyles.addImg)} />
            </div>
          }

          <Slider
            {...relativeImageSliderSettings}
            className={css(Styles.slider)}
            initialSlide={this.state.selectedImageIndex} >
            {eventImages.length > 0 &&
              eventImages.map(option => {
                return (
                  <div className={css(Styles.eventImageSpecContainer)}>
                    <img
                      src={option}
                      key={option}
                      className={css(Styles.eventImageSpec)} />
                  </div>
                )
              })}
          </Slider>
        </div>
      )
    }
  }


  onPlay = () => {
    if (this.play) {
      this.play = false;
      this.pause = true;
      this.setState({
        player: 'play_arrow'
      })
      if (this.playerFnId) {
        clearInterval(this.playerFnId);
      }
    } else {
      this.pause = false;
      this.play = true;
      this.setState({
        player: 'pause'
      })
      this.playerFnId = setInterval(() => {
        this.playEvent();
      }, AppConfig.jpegPlayerRefreshInterval);
    }
  }

  playEvent = () => {
    if (this.props.eventIndex === (this.props.eventList.length - 1)) {
      if (this.play) {
        this.onPlay()
      }
      return;
    }
    this.props.onEventTileSelect(this.props.eventList[this.props.eventIndex + 1], this.props.eventIndex + 1)
  }

  eventNext = () => {
    this.props.onEventTileSelect(this.props.eventList[this.props.eventIndex + 1], this.props.eventIndex + 1)
  }

  eventBefore = () => {
    this.props.onEventTileSelect(this.props.eventList[this.props.eventIndex - 1], this.props.eventIndex - 1)
  }

  renderEventControls = (item) => {
    if (!item) return

    return (
      <div className={this.props.relativeImageSliderMode ? css(Styles.eventControlContentRelativeOpen) : css(Styles.eventControlContent)} >
        <div className={css(Styles.eventInnerControlContent)}>
          <div className={css(Styles.eventInnerControl)}>
            <div
              className={
                this.props.eventIndex === 0 ?
                  css(Styles.eventInnerControlImgConatinerLast) :
                  css(Styles.eventInnerControlImgConatiner)
              }
              onClick={() => this.eventBefore(item)}>
              <Icon className={css(Styles.eventPlayerIcon)}>
                skip_previous
              </Icon>
            </div>
            <p className={css(Styles.eventInnerControlImgTitle)}>Previous Event</p>
          </div>
          <div className={css(Styles.eventInnerControl)}>
            <div
              className={
                this.props.eventIndex === (this.props.eventList.length - 1) ?
                  css(Styles.eventInnerControlImgConatinerLast) :
                  css(Styles.eventInnerControlImgConatiner)
              }
              onClick={() => this.onPlay()}>
              <Icon className={css(Styles.eventPlayerIcon)}>
                {this.state.player}
              </Icon>
            </div>
            <p className={css(Styles.eventInnerControlImgTitle)}>Pause Slideshow</p>
          </div>
          <div className={css(Styles.eventInnerControl)}>
            <div
              className={
                this.props.eventIndex === (this.props.eventList.length - 1) ?
                  css(Styles.eventInnerControlImgConatinerLast) :
                  css(Styles.eventInnerControlImgConatiner)
              }
              onClick={() => this.eventNext()}>
              <Icon className={css(Styles.eventPlayerIcon)}>
                skip_next
              </Icon>
            </div>
            <p className={css(Styles.eventInnerControlImgTitle)}>Next Event</p>
          </div>
        </div>
      </div>
    )
  }

  renderEventEditContainer = (item) => {
    if (!item) return

    return (
      <div className={css(Styles.eventEditOuterContainer)}>
        <div className={css(Styles.eventEditContainer)}>
          {Controller.get().userMgr().isAdminUser() &&
            <Tooltip title={'EDIT EVENT'}>
              <div className={css(Styles.eventEditImgContainer)}>
                <div className={css(Styles.eventEditImg)} onClick={() => this.props.showEventEditor(item)}>
                  <img src={require('../../assets/images/edit-img.svg')} />
                </div>
                {/*<p className={css(Styles.eventInnerControlImgTitle, Styles.eventEdit)}>Edit</p>*/}
              </div>
            </Tooltip>
          }
          {!this.props.independentEventDetails && this.props.selectedEvent && this.props.selectedEvent._id &&
            <Tooltip title={'EVENT DETAILS'}>
              <Link
                to={{
                  pathname: '/events/' + this.props.selectedEvent._id,
                }}
                target={'_blank'}
                className={css(Styles.link)}>
                <div className={css(Styles.eventEditImgContainer)}>
                  <div className={css(Styles.eventEditImg)}>
                    <Icon
                      className={css(Styles.openEventIcon)}>
                      open_in_new
                    </Icon>
                  </div>
                </div>
              </Link>
            </Tooltip>
          }
        </div>
        {
          this.props.liveUrl && this.props.camId &&
          <div className={css(Styles.eventLiveFeedContainer)}>
            <Link
              to={{
                pathname: '/places/' + this.props.placeId + '/cams/' + this.props.camId,
                state: {
                  eventId: this.props.independentEventDetails && this.props.selectedEvent && this.props.selectedEvent._id
                } // To decide back path name
              }}
              className={css(Styles.link)}>
              <div className={css(Styles.eventLiveFeedContent)}>
                <p className={css(CommonStyles.margin)}>VIEW LIVE FEED</p></div>
            </Link>
          </div>
        }
      </div >
    )
  }

  renderEvenImageSliderMini = (item) => {
    if (!item) return
    const eventImages = this.processImages(item)
    console.log('eventImages', eventImages)
    if (eventImages && eventImages.length > 0) {
      let setting = {}
      let relativeLess = false
      let marginLeftRequired = false
      if (eventImages.length < 3) {
        marginLeftRequired = true
      }
      if (eventImages.length < 2) {
        setting = relativesettingsLess
        relativeLess = true
      } else {
        setting = relativesettings
      }
      return (
        <div>
          <div className={css(Styles.relatedImageHeaderContainer)}>
            <p className={css(Styles.relatedImageTitile)}>Related Images &nbsp;({eventImages.length})</p>
          </div>
          {
            this.props.independentEventDetails &&
            <Grid container spacing={2} className={css(Styles.gridImageContainer)}  >
              {eventImages.length > 0 &&
                eventImages.map((imageUrl, index) => {
                  return (
                    <Grid item xs={6} sm={6}>
                      <div
                        className={relativeLess ? css(Styles.eventRelativeImage, Styles.eventRelativeImageLess) : css(Styles.eventRelativeImage)}
                        onClick={() => this.showRelatedImages(index)}>
                        <div className={(this.state.selectedImageIndex === index) ?
                          css(Styles.eventRelativeImageContent, Styles.highlightRelative) : css(Styles.eventRelativeImageContent)}>
                          <img
                            src={imageUrl}
                            key={imageUrl}
                            onError={(e) => {
                              e.target.src = require('../../assets/images/error2.svg')
                            }}
                            className={css(Styles.relativeImageContent)} />
                        </div>
                      </div>
                    </Grid>
                  )
                })

              }
            </Grid>
          }
          {!this.props.independentEventDetails &&
            <div>
              <Slider {...setting}
                className={marginLeftRequired ? css(Styles.relativeSettingsWithMargin) : css(Styles.relativeSettings)}>
                {eventImages.length > 0 &&
                  eventImages.map((imageUrl, index) => {
                    return (
                      <div
                        className={relativeLess ? css(Styles.eventRelativeImage, Styles.eventRelativeImageLess) : css(Styles.eventRelativeImage)}
                        onClick={() => this.showRelatedImages(index)}>
                        <div className={(this.state.selectedImageIndex === index) ?
                          css(Styles.eventRelativeImageContent, Styles.highlightRelative) : css(Styles.eventRelativeImageContent)}>
                          <img
                            src={imageUrl}
                            key={imageUrl}
                            onError={(e) => {
                              e.target.src = require('../../assets/images/error2.svg')
                            }}
                            className={css(Styles.relativeImageContent)} />
                        </div>
                      </div>
                    )
                  })}
              </Slider>
            </div>
          }
        </div>
      )
    }
    return ''
  }

  renderEventSliderMini = (item) => {
    if (!item) return

    let eventsRel = [item]

    if (this.props.eventsByGroupId[item.groupId] &&
      this.props.eventsByGroupId[item.groupId].length > 0) {

      eventsRel = eventsRel.concat(this.props.eventsByGroupId[item.groupId])

      let setting = {}
      let relativeLess = false

      if (eventsRel.length < 2) {
        setting = relativesettingsLess
        relativeLess = true
      } else {
        setting = relativesettings
      }

      let marginLeftRequired = false
      if (eventsRel.length < 3) {
        marginLeftRequired = true
      }

      return (
        <div>
          <div className={css(Styles.relatedImageHeaderContainer)}>
            <p className={css(Styles.relatedImageTitile)}>Related Events &nbsp;({eventsRel.length})</p>
          </div>
          <Slider {...setting}
            className={marginLeftRequired ? css(Styles.relativeSettingsWithMargin) : css(Styles.relativeSettings)}>
            {eventsRel.map((option, index) => {
              return (
                <div
                  className={relativeLess ? css(Styles.eventRelativeImage, Styles.eventRelativeImageLess) : css(Styles.eventRelativeImage)}
                  onClick={() => this.showRelatedEvents(index, option)}>
                  <div
                    className={(this.state.selectedRelatedEventIndex === (index)) ?
                      css(Styles.eventRelativeImageContent, Styles.highlightRelative) : css(Styles.eventRelativeImageContent)}>
                    <img
                      src={option.image}
                      key={option.image}
                      onError={(e) => {
                        e.target.src = require('../../assets/images/error2.svg')
                      }}
                      className={css(Styles.relativeImageContent)}></img>
                    <div className={css(Styles.eventListTitleConatiner, Styles.eventListTitleConatinerCust)}>
                      <p className={css(Styles.eventListTitle, Styles.eventListTitleCust)}>{option.name}</p>
                      <div className={css(Styles.eventListDateContainer)}>
                        <p className={css(Styles.eventListDate, Styles.eventListDateCust)}>
                          {moment(option.event_time).format('MMM DD, YYYY, h:mm:ss A')}</p>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </Slider>
        </div>
      )
    }
    return ''
  }

  getEventItemHeaderContainerStyle = () => {
    if (this.props.independentEventDetails) {
      return css(Styles.eventItemHeaderContainer, Styles.eventItemHeaderContainerSpec)
    } else {
      return css(Styles.eventItemHeaderContainer)
    }
  }

  getEventItemOuterContainerStyle = () => {
    if (this.props.independentEventDetails) {
      return css(Styles.eventItemOuterContainer, Styles.eventItemOuterContainerSpec)
    } else {
      return css(Styles.eventItemOuterContainer)
    }
  }

  renderEventInfo = (item) => {
    let itemToRender = item
    let imageUrl = item ? item.image : null
    if (this.props.selectedRelatedEvent) {
      itemToRender = this.props.selectedRelatedEvent
      imageUrl = this.props.selectedRelatedEvent.image
    }

    return (
      <div
        className={this.getEventItemOuterContainerStyle()}>
        <div
          className={this.getEventItemHeaderContainerStyle()} >

          {this.renderEventHeader(itemToRender)}

          {this.props.relativeImageSliderMode &&
            <div>
              <div>
                {this.renderRelativeImageSlider(itemToRender)}
              </div>
            </div>
          }

          {!this.props.relativeImageSliderMode && imageUrl &&
            <div className={css(Styles.eventImageContent)} style={{ minHeight: this.imgContainerHeight }}>
              <img
                key={imageUrl}
                src={imageUrl}
                className={css(Styles.eventImage)}
                onError={(e) => {
                  e.target.src = require('../../assets/images/error2.svg')
                }} />
            </div>
          }

          {
            !this.props.independentEventDetails &&
            this.renderEventControls(item)}
        </div>

        <div className={this.props.relativeImageSliderMode ?
          css(Styles.eventItemFeatureContainerRelativeOpen)
          :
          css(Styles.eventItemFeatureContainer)}>

          {this.renderEventEditContainer(itemToRender)}

          {this.renderEvenImageSliderMini(itemToRender)}

          {this.renderEventSliderMini(item)}
        </div>

      </div>
    )
  }

  render = () => {
    return this.renderEventInfo(this.props.selectedEvent)
  }
}


// WEBPACK FOOTER //
// ./src/screens/ClientPlace/EventDetails.js